import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalAccountsTable from './portal-accounts-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-portal-admin-portal-financials')) {
  ReactDOM.render(<PortalAccountsTable
    url= "/api/v1/portal/portal-admin/portal-financials"
    message_if_none = 'No portal financials yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-portal-admin-portal-financials'));
}
